
















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import { NotificationModel } from '@/models/notification';

import commonServices from '@/services/common-services';

@Component({
    components: {
        Loading
    }
})
export default class Notification extends Vue {
    private pageSettings = {
        rowPerPage: 10,
        pageSize: 3,
        pageIndex: 1,
        total: 0,
    };
    private listNotification: NotificationModel[] = [];
    private isLoading = false;
    private stopLoad = false;

    private status = false;

    @Watch('status', { immediate: true, deep: true })
    private async watchStatus() {
        this.pageSettings.pageIndex = 1;
        this.listNotification = [];
        this.loadNotification();
    }

    private buildFilter() {
        if (this.status === true) {return [];}
        if (this.status === false) {return [{ column: 'Status', value: [0,2], condition: 'in' }];}
        return [];
    }

    private async loadNotification() {
        this.isLoading = true;
        const filter = this.buildFilter();
        const result = await commonServices.getNotification(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filter, false);
        if (result && result.status === 200 && result.data.status === 200) {
            for (const item of result.data.data) {
                const notification = new NotificationModel();
                notification.createdDate = item.CreatedDate;
                notification.id = item.ID;
                notification.isBuy = item.IsBuy;
                notification.mainOrder = item.MainOrder;
                notification.message = item.Message;
                notification.orderId = item.OrderID;
                notification.orderType = item.OrderType;
                notification.receivedId = item.ReceivedID;
                notification.status = item.Status;

                this.listNotification.push(notification);
            }

            if (result.data.data.length === 0) {
                this.stopLoad = true;
            } else {
                this.stopLoad = false;
            }
        }
        this.isLoading = false;
    }

    private async onReadNotification(notif: NotificationModel) {
        try {
            
            if (notif.status === 0 || notif.status === 2) {
                this.isLoading = true;
                await commonServices.updateStatusNotification(notif.id, { Status: 1 });
                eventBus.$emit(APP_CONFIG.eventBusAction.reloadNotification, null);
                this.isLoading = false;
            }

            // this.$router.push({ name: 'order-detail', params: { orderId: notif.orderId.toString() } }).catch(() => {
            //     return false;
            // });
        } catch {
            return false;
        }
    }

    private async loadMore() {
        this.pageSettings.pageIndex++;
        this.loadNotification();
    }
}
